export default "__VITE_ASSET__ySbtkRoj__"